var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 38v-3.292a4 4 0 0 0-2.514-3.714l-4.069-1.627a4 4 0 0 0-5.063 1.925L30 32s-5-1-9-5-5-9-5-9l.708-.354a4 4 0 0 0 1.925-5.063l-1.627-4.069A4 4 0 0 0 13.292 6H10a4 4 0 0 0-4 4c0 17.673 14.327 32 32 32a4 4 0 0 0 4-4Z",
    stroke: "#141718",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.da20665c5b192afaf2934808f55c9fe6.svg";
export { ForwardRef as ReactComponent };